import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadDangerousGoodsQueryVariables = {};


export type ReadDangerousGoodsQuery = (
  { __typename?: 'Query' }
  & { dangerousGoods: Array<(
    { __typename?: 'DangerousGood' }
    & Pick<Types.DangerousGood, '_id' | '_deleted' | 'unNumber' | 'description' | 'created' | 'modified'>
    & { modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name' | 'email' | 'department' | 'roles' | 'firstName' | 'lastName'>
    )>, createdBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name' | 'email' | 'department' | 'roles' | 'firstName' | 'lastName'>
    )> }
  )> }
);

export type CreateDangerousGoodMutationVariables = {
  input?: Types.Maybe<Types.DangerousGoodInsertType>
};


export type CreateDangerousGoodMutation = (
  { __typename?: 'Mutation' }
  & { createDangerousGood: (
    { __typename?: 'DangerousGood' }
    & Pick<Types.DangerousGood, '_id'>
  ) }
);

export type UpdateDangerousGoodMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.DangerousGoodSetType>
};


export type UpdateDangerousGoodMutation = (
  { __typename?: 'Mutation' }
  & { updateDangerousGood: Array<(
    { __typename?: 'DangerousGood' }
    & Pick<Types.DangerousGood, '_id'>
  )> }
);

export type DeleteDangerousGoodMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteDangerousGoodMutation = (
  { __typename?: 'Mutation' }
  & { deleteDangerousGood: Array<(
    { __typename?: 'DangerousGood' }
    & Pick<Types.DangerousGood, '_deleted'>
  )> }
);

export const ReadDangerousGoodsDocument = gql`
    query ReadDangerousGoods {
  dangerousGoods {
    _id
    _deleted
    unNumber
    description
    modifiedBy {
      _id
      name
      email
      department
      roles
      firstName
      lastName
    }
    createdBy {
      _id
      name
      email
      department
      roles
      firstName
      lastName
    }
    created
    modified
  }
}
    `;

    export function useReadDangerousGoodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadDangerousGoodsQuery, ReadDangerousGoodsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadDangerousGoodsQuery, ReadDangerousGoodsQueryVariables>(ReadDangerousGoodsDocument, baseOptions);
    };
      export function useReadDangerousGoodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadDangerousGoodsQuery, ReadDangerousGoodsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadDangerousGoodsQuery, ReadDangerousGoodsQueryVariables>(ReadDangerousGoodsDocument, baseOptions);
      };
      
export type ReadDangerousGoodsQueryHookResult = ReturnType<typeof useReadDangerousGoodsQuery>;
export type ReadDangerousGoodsQueryResult = ApolloReactCommon.QueryResult<ReadDangerousGoodsQuery, ReadDangerousGoodsQueryVariables>;
export const CreateDangerousGoodDocument = gql`
    mutation CreateDangerousGood($input: DangerousGoodInsertType) {
  createDangerousGood(input: $input) {
    _id
  }
}
    `;
export type CreateDangerousGoodMutationFn = ApolloReactCommon.MutationFunction<CreateDangerousGoodMutation, CreateDangerousGoodMutationVariables>;

    export function useCreateDangerousGoodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDangerousGoodMutation, CreateDangerousGoodMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateDangerousGoodMutation, CreateDangerousGoodMutationVariables>(CreateDangerousGoodDocument, baseOptions);
    };
export type CreateDangerousGoodMutationHookResult = ReturnType<typeof useCreateDangerousGoodMutation>;
export type CreateDangerousGoodMutationResult = ApolloReactCommon.MutationResult<CreateDangerousGoodMutation>;
export type CreateDangerousGoodMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDangerousGoodMutation, CreateDangerousGoodMutationVariables>;
export const UpdateDangerousGoodDocument = gql`
    mutation UpdateDangerousGood($id: ID, $update: DangerousGoodSetType) {
  updateDangerousGood(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
  }
}
    `;
export type UpdateDangerousGoodMutationFn = ApolloReactCommon.MutationFunction<UpdateDangerousGoodMutation, UpdateDangerousGoodMutationVariables>;

    export function useUpdateDangerousGoodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDangerousGoodMutation, UpdateDangerousGoodMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateDangerousGoodMutation, UpdateDangerousGoodMutationVariables>(UpdateDangerousGoodDocument, baseOptions);
    };
export type UpdateDangerousGoodMutationHookResult = ReturnType<typeof useUpdateDangerousGoodMutation>;
export type UpdateDangerousGoodMutationResult = ApolloReactCommon.MutationResult<UpdateDangerousGoodMutation>;
export type UpdateDangerousGoodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDangerousGoodMutation, UpdateDangerousGoodMutationVariables>;
export const DeleteDangerousGoodDocument = gql`
    mutation DeleteDangerousGood($ids: [ID!]!) {
  deleteDangerousGood(filter: {_id: {IN: $ids}}) {
    _deleted
  }
}
    `;
export type DeleteDangerousGoodMutationFn = ApolloReactCommon.MutationFunction<DeleteDangerousGoodMutation, DeleteDangerousGoodMutationVariables>;

    export function useDeleteDangerousGoodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDangerousGoodMutation, DeleteDangerousGoodMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteDangerousGoodMutation, DeleteDangerousGoodMutationVariables>(DeleteDangerousGoodDocument, baseOptions);
    };
export type DeleteDangerousGoodMutationHookResult = ReturnType<typeof useDeleteDangerousGoodMutation>;
export type DeleteDangerousGoodMutationResult = ApolloReactCommon.MutationResult<DeleteDangerousGoodMutation>;
export type DeleteDangerousGoodMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDangerousGoodMutation, DeleteDangerousGoodMutationVariables>;